import { getAccessToken, sessionBindingFromJwt } from "./authTokenStore.js";

export const DIRECTORY_OAUTH_SESSION_REQUEST = "directory-oauth-session-request";
export const DIRECTORY_OAUTH_SESSION_RESPONSE = "directory-oauth-session-response";
export const DIRECTORY_OAUTH_RESULT = "directory-oauth-result";

const WINDOW_NAME_PREFIX = "origin-directory-oauth:";

export function authBindingKey(binding) {
    if (
        typeof binding?.issuer !== "string" || binding.issuer.length === 0
        || typeof binding?.subject !== "string" || binding.subject.length === 0
        || typeof binding?.sessionId !== "string" || binding.sessionId.length === 0
        || typeof binding?.tenant !== "string" || binding.tenant.length === 0
    ) return null;
    return `${binding.issuer}\u0000${binding.subject}\u0000${binding.sessionId}\u0000${binding.tenant}`;
}

export function sameAuthBinding(left, right) {
    const leftKey = authBindingKey(left);
    return leftKey !== null && leftKey === authBindingKey(right);
}

export function currentDirectoryOauthBinding() {
    return sessionBindingFromJwt(getAccessToken());
}

function randomRequestId() {
    const bytes = new Uint8Array(24);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function directoryOauthWindowName(requestId) {
    return `${WINDOW_NAME_PREFIX}${requestId}`;
}

export function readDirectoryOauthRequestId(name = window.name) {
    if (typeof name !== "string" || !name.startsWith(WINDOW_NAME_PREFIX)) return null;
    const requestId = name.slice(WINDOW_NAME_PREFIX.length);
    return /^[a-f0-9]{48}$/.test(requestId) ? requestId : null;
}

export function createDirectoryOauthPending({ integrationId, provider, redirectUri }) {
    const binding = currentDirectoryOauthBinding();
    if (!binding) throw new Error("The current dashboard session is not bound to a tenant.");
    const requestId = randomRequestId();
    return {
        integrationId,
        provider,
        redirectUri,
        requestId,
        binding,
        createdAt: Date.now(),
        windowName: directoryOauthWindowName(requestId),
    };
}

export function isDirectoryOauthPending(pending, requestId) {
    return typeof pending?.integrationId === "string"
        && typeof pending?.provider === "string"
        && typeof pending?.redirectUri === "string"
        && pending?.requestId === requestId
        && authBindingKey(pending?.binding) !== null;
}

export function isDirectoryOauthRequest(event, { source, requestId }) {
    if (event?.origin !== window.location.origin || event?.source !== source) return false;
    return event?.data?.type === DIRECTORY_OAUTH_SESSION_REQUEST
        && event?.data?.requestId === requestId;
}

export function isDirectoryOauthMessage(event, { source, requestId, binding, type }) {
    if (event?.origin !== window.location.origin || event?.source !== source) return false;
    const message = event?.data;
    return message?.type === type
        && message?.requestId === requestId
        && sameAuthBinding(message?.authBinding, binding);
}
